import script from "./HrWorkforcePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./HrWorkforcePanel.vue?vue&type=script&setup=true&lang=js"

import "./hrWorkforce.css?vue&type=style&index=0&id=00d022b4&scoped=true&lang=css"
import "./HrWorkforcePanel.vue?vue&type=style&index=1&id=00d022b4&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00d022b4"]])

export default __exports__